import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody, encodeToBase64 } from '@/utils'

export default {
    fetchAll(sortName = "chat_tickets.customers.name", page, itemsPerPage, type = "ASC", word = "", status_id = null) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        const params = {
            is_pre_order: false,
            orderBy: [sortName, type],
            search_filter: word,
            pagination_page: page,
            pagination_limit: itemsPerPage
        }

        if (status_id !== null) {
            params.status_id = status_id;
        }

        return axios.post('', formatGraphqlBody(
            'query',
            'getOrder',
            {
                0: 'pagination_page',
                1: 'pagination_limit',
                2: 'total_pages',
                3: 'total_items',
                items: {
                    0: 'id',
                    status: {
                        0: 'id',
                        1: 'name',
                        2: 'step',
                        3: 'color'
                    },
                    1: 'chat_ticket_id',
                    2: 'purchase_value',
                    3: 'is_canceled',
                    4: 'status_id',
                    5: 'is_delivery',
                    6: 'is_pre_order',
                    7: 'erp_id',
                    8: 'address',
                    9: 'payment_id',
                    10: 'is_finished_at',
                    11: 'payment_data',
                    12: 'created_at',
                    13: 'updated_at',
                    erp: {
                        0: 'erp_id'
                    },
                    orderProducts: {
                        0: 'id',
                        1: 'order_id',
                        2: 'product_id',
                        3: 'quantity',
                        4: 'discount_price'
                    },
                    user: {
                        0: 'id',
                        1: 'email',
                        2: 'name',
                        3: 'username'
                    },
                    chatTicket: {
                        0: 'id',
                        customer: {
                            0: 'id',
                            1: 'name',
                            2: 'phone_number',
                            3: 'image',
                            4: 'document_register',
                            5: 'address'
                        },
                        1: 'started_at',
                        2: 'finished_at',
                        3: 'protocol',
                        4: 'user_id',
                        5: 'instance_id',
                        6: 'customer_id'
                    },
                    services: {
                        0: 'id',
                        1: 'name',
                        2: 'price',
                        3: 'category',
                        4: 'scheduled_at',
                        5: 'completed_at',
                        6: 'discount_price'
                    },
                    14: 'turned_order_at',
                    15: 'files',
                    16: 'note',
                    reason: {
                        0: 'id',
                        1: 'description',
                        2: 'use_observation',
                        3: 'require_observation',
                        4: 'type'
                    },
                    17: 'customer_knowledge_content'
                }
            },
            params
        ));
    },
    fetchAllPreOrders(sortName = "chat_tickets.customers.name", page, itemsPerPage, type = "ASC", word = "", customerId = null) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', formatGraphqlBody(
            'query',
            'getOrder',
            {
                0: 'pagination_page',
                1: 'pagination_limit',
                2: 'total_pages',
                3: 'total_items',
                items: {
                    0: 'id',
                    status: {
                        0: 'id',
                        1: 'name',
                        2: 'step',
                        3: 'color'
                    },
                    1: 'chat_ticket_id',
                    2: 'purchase_value',
                    3: 'is_canceled',
                    4: 'status_id',
                    5: 'is_delivery',
                    6: 'is_pre_order',
                    7: 'erp_id',
                    8: 'address',
                    9: 'payment_id',
                    10: 'is_finished_at',
                    11: 'payment_data',
                    12: 'created_at',
                    13: 'updated_at',
                    erp: {
                        0: 'erp_id'
                    },
                    orderProducts: {
                        0: 'id',
                        product: {
                            0: 'id',
                            1: 'name',
                            2: 'price',
                            3: 'amount',
                            4: 'description',
                            5: 'category',
                            6: 'image',
                            7: 'brand',
                            8: 'bar_code',
                            9: 'is_medication',
                            10: 'active_principle',
                            11: 'need_prescription',
                            12: 'deleted_at',
                            13: 'integration_id',
                        },
                        1: 'order_id',
                        2: 'product_id',
                        3: 'quantity',
                        4: 'discount_price'
                    },
                    erp: {
                        0: 'id',
                        1: 'corporate_name',
                        2: 'erp_name',
                        3: 'erp_id'
                    },
                    user: {
                        0: 'id',
                        1: 'email',
                        2: 'name',
                        3: 'username'
                    },
                    chatTicket: {
                        0: 'id',
                        customer: {
                            0: 'id',
                            1: 'name',
                            2: 'phone_number',
                            3: 'image'
                        },
                        1: 'started_at',
                        2: 'finished_at',
                        3: 'protocol',
                        4: 'user_id',
                        5: 'instance_id',
                        6: 'customer_id'
                    },
                    services: {
                        0: 'id',
                        1: 'name',
                        2: 'price',
                        3: 'category',
                        4: 'scheduled_at',
                        5: 'completed_at',
                        6: 'discount_price'
                    },
                    14: 'turned_order_at',
                    15: 'files',
                    16: 'note',
                    reason: {
                        0: 'id',
                        1: 'description',
                        2: 'use_observation',
                        3: 'require_observation',
                        4: 'type'
                    },
                    17: 'customer_knowledge_content'
                }
            },
            {
                is_pre_order: true,
                orderBy: [sortName, type],
                search_filter: word,
                pagination_page: page,
                pagination_limit: itemsPerPage,
                customer_id: customerId
            }
        ));
    },
    transformPreOrderIntoOrder(id, send_notification = undefined, service = undefined, customer_id = undefined, reason_id = undefined) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    transformPreOrderIntoOrder (
                        id: ${id},
                        ` + (customer_id === undefined ? '' : `customer_id: ${customer_id}`) + `,
                        ` + (reason_id === undefined ? '' : `reason_id: ${reason_id}`) + `,
                        ` + (send_notification === undefined ? '' : `send_notification: ${send_notification}`) + `,
                        ` + (service === undefined ? '' : `service: """${service}"""`) + `,
                    )
                }
            `
        })
    },
    createPreOrder(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    createPreOrder (
                        chat_ticket_id: ${data.chat_ticket_id},
                        purchase_value: ${data.purchase_value},
                        is_pre_order: ${data.is_pre_order},
                        payment_data: """${data.payment_data}""",
                        ` + (data.status_id === undefined ? '' : `status_id: ${data.status_id},`) + `
                        ` + (data.is_delivery === undefined ? '' : `is_delivery: ${data.is_delivery},`) + `
                        ` + (data.address === undefined || data.address === null ? '' : `address: """${data.address}"""`) + `,
                        ` + (data.erp_id === undefined || data.erp_id === null ? '' : `erp_id: ${data.erp_id},`) + `
                        ` + (data.user_id === undefined || data.user_id === null ? '' : `user_id: ${data.user_id},`) + `
                        ` + (data.product === undefined ? '' : `product: """${data.product}"""`) + `,
                        ` + (data.service === undefined ? '' : `service: """${data.service}"""`) + `,
                        ` + (data.customer_id === undefined ? '' : `customer_id: ${data.customer_id}`) + `,
                        ` + (data.files === null ? '' : `files: """${data.files}"""`) + `,
                        ` + (data.note === null ? '' : `note: "${encodeToBase64(data.note)}"`) + `,
                        ` + (data.reason_id === null ? '' : `reason_id: ${data.reason_id}`) + `,
                        ` + (!data.currentKnow ? '' : `customer_knowledge_content: """${data.currentKnow}"""`) + `,
                    ) {
                        id,
                        chat_ticket_id,
                        purchase_value,
                        is_canceled,
                        status_id,
                        is_delivery,
                        is_pre_order,
                        erp_id,
                        address,
                        payment_id,
                        is_finished_at,
                        created_at,
                        updated_at,
                        payment_data,
                        turned_order_at,
                        status {
                            id,
                            name,
                            step,
                            color
                        },
                        erp {
                             erp_id
                        },
                        orderProducts {
                            id,
                            order_id,
                            product_id,
                            quantity,
                            discount_price
                        },
                        chatTicket {
                            id,
                            started_at,
                            finished_at,
                            protocol,
                            user_id,
                            instance_id,
                            customer {
                                id,
                                name,
                                phone_number,
                                image
                            }
                        },
                        services {
                            id,
                            name,
                            price,
                            category,
                            description,
                            recurrence,
                            scheduled_at,
                            completed_at,
                            discount_price,
                        },
                        files,
                        note                        
                    }
                }
            `
        })
    },
    update(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    updateOrder (
                        id: ${data.id},
                        ` + (data.purchase_value === undefined || data.purchase_value === null ? '' : `purchase_value: ${data.purchase_value},`) + `
                        ` + (data.is_delivery === undefined || data.is_delivery === null ? '' : `is_delivery: ${data.is_delivery},`) + `
                        ` + (data.address === undefined || data.address === null ? '' : `address: """${data.address}""",`) + `
                        ` + (data.payment_data === undefined || data.payment_data === null ? '' : `payment_data: """${data.payment_data}""",`) + `
                        ` + (data.status_id === undefined || data.status_id === null ? '' : `status_id: ${data.status_id},`) + `,
                        ` + (data.note === undefined || data.note === null ? '' : `note: "${encodeToBase64(data.note)}",`) + `,
                        ` + (data.files === undefined || data.files === null ? '' : `files: """${data.files}""",`) + `,
                        ` + (data.currentKnow === undefined ? '' : (data.currentKnow === null ? `customer_knowledge_content: ${data.currentKnow}` : `customer_knowledge_content: """${data.currentKnow}"""`)) + `,
                    ) {
                        id,
                        chat_ticket_id,
                        purchase_value,
                        is_canceled,
                        status_id,
                        is_delivery,
                        is_pre_order,
                        erp_id,
                        address,
                        payment_id,
                        is_finished_at,
                        created_at,
                        updated_at,
                        payment_data,
                        turned_order_at,
                        status {
                            id,
                            name,
                            step,
                            color
                        },
                        erp {
                            erp_id
                        },
                        orderProducts {
                            id,
                            order_id,
                            product_id,
                            quantity,
                            discount_price
                        },
                        chatTicket {
                            id,
                            started_at,
                            finished_at,
                            protocol,
                            user_id,
                            instance_id,
                            customer_id,
                            customer {
                                id,
                                name,
                                phone_number,
                                image
                            }
                        }
                    }
                }
            `
        })
    },
    deleteOrder(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteOrder (
                        id: ${id}
                    )
                }
            `
        })
    },
    finishOrder(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    finishOrder (
                        id: ${id}
                    )
                }
            `
        })
    }
}